/**
 * 표시용 USD 환율 — Frankfurter(ECB) 공개 API를 FE에서 직접 호출 (BE 불필요).
 *  · 키 불필요·CORS 지원·무제한 → 브라우저 직접 호출 가능
 *  · 1 USD = N KRW 반환. 실패 시 throw → FxRateProvider 가 KRW 폴백
 *  · FxRateProvider 가 세션당 1회만 호출 (캐시)
 */
const FRANKFURTER_URL = 'https://api.frankfurter.dev/v1/latest?from=USD&to=KRW';

export const getFxRate = async () => {
  const res = await fetch(FRANKFURTER_URL);
  if (!res.ok) throw new Error(`FX fetch failed: ${res.status}`);
  const data = await res.json();
  const rate = Number(data && data.rates && data.rates.KRW);
  if (!Number.isFinite(rate) || rate <= 0) throw new Error('FX rate invalid');
  return { rate, as_of: data.date || null }; // { rate, as_of }
};
